
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoggedInViewer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Viewer"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cioIdentifier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cioFingerprint"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneVerified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneVerificationPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"connectedToFacebook"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"connectedToGoogle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasVisibleListing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasAnyListing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstStateForCurrentSite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"involvedInConversations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"directoryPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isProvider"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oppositeTypeKeyword"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oppositeTypeKeywordPlural"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unreadMessagesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailDigest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listing"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isApproved"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featured"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hireReasons"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editHireReasonsPath"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"domain"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"providerName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"businessModel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pluralProviderName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pluralSuffixedSeekerName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"multipleSeekerListings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"googleAppId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profileEligibleForUpgrade"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSubscribed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasActiveListing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasTelesafe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"authState"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":909}};
    doc.loc.source = {"body":"fragment LoggedInViewer on Viewer {\n  user {\n    id\n    userId\n    cioIdentifier\n    cioFingerprint\n    email\n    phoneNumber\n    phoneVerified\n    phoneVerificationPath\n    connectedToFacebook\n    connectedToGoogle\n    firstName\n    lastName\n    hasVisibleListing\n    hasAnyListing\n    firstStateForCurrentSite\n    createdAt\n    userType\n    involvedInConversations\n    directoryPath\n    isProvider\n    oppositeTypeKeyword\n    oppositeTypeKeywordPlural\n    unreadMessagesCount\n    emailDigest\n    listing {\n      _id\n      isApproved\n      featured\n      hireReasons\n      editHireReasonsPath\n    }\n    \n  }\n  site {\n    _id\n    name\n    domain\n    pageTitle\n    providerName\n    businessModel\n    pluralProviderName\n    pluralSuffixedSeekerName\n    multipleSeekerListings\n    googleAppId\n  }\n  currency\n  countryCode\n  profileEligibleForUpgrade\n  isSubscribed\n  hasActiveListing\n  hasTelesafe\n  authState\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["LoggedInViewer"] = oneQuery(doc, "LoggedInViewer");
        
